export default __webpack_public_path__ + "static/media/bid.29334e7b.png";